export const ADD_TODO = "ADD_TODO";
export const DELETE_TODO = "DELETE_TODO";
export const COMPLETE_TODO = "COMPLETE_TODO";
export const SET_FILTER = "SET_FILTER";
export const CLEAR_COMPLETED = "CLEAR_COMPLETED";
